import React from "react";
import "../styles/components/error_button.css";

const ErrorButton = ({ text, icon, styleType = "green", onClick }) => {
    const buttonClass = styleType === "green" ? "error-btn error-btn-green" : "error-btn error-btn-white";

    return (
        <button className={buttonClass} onClick={onClick}>
            {icon && <img src={icon} alt="icon" className="error-btn-icon" />}
            {text && <span className="error-btn-text">{text}</span>}
        </button>
    );
};

export default ErrorButton;